import { Home2Icon } from "@solar-icons/react/outline/home-2";
import { DatabaseIcon } from "@solar-icons/react/outline/database";
import { Tuning2Icon } from "@solar-icons/react/outline/tuning-2";
import { PlaneIcon } from "@solar-icons/react/outline/plane";
import { CityIcon } from "@solar-icons/react/outline/city";
import { Buildings2Icon } from "@solar-icons/react/outline/buildings-2";
import { CaseMinimalisticIcon } from "@solar-icons/react/outline/case-minimalistic";
import { Shop2Icon } from "@solar-icons/react/outline/shop-2";
import { Buildings3Icon } from "@solar-icons/react/outline/buildings-3";
import { UserIdIcon } from "@solar-icons/react/outline/user-id";
import { UsersGroupRoundedIcon } from "@solar-icons/react/outline/users-group-rounded";
import { PointOnMapIcon } from "@solar-icons/react/outline/point-on-map";
import { ExportIcon } from "@solar-icons/react/outline/export";
import { ImportIcon } from "@solar-icons/react/outline/import";
import { ChatRoundCheckIcon } from "@solar-icons/react/outline/chat-round-check";
import { TagPriceIcon } from "@solar-icons/react/outline/tag-price";
import { FileTextIcon } from "@solar-icons/react/outline/file-text";
import { BuildingsIcon } from "@solar-icons/react/outline/buildings";
import { InboxOutIcon } from "@solar-icons/react/outline/inbox-out";
import { InboxInIcon } from "@solar-icons/react/outline/inbox-in";
import { InboxIcon } from "@solar-icons/react/outline/inbox";
import { SafeSquareIcon } from "@solar-icons/react/outline/safe-square";
import { SafeCircleIcon } from "@solar-icons/react/outline/safe-circle";
import { DocumentTextIcon } from "@solar-icons/react/outline/document-text";
import { DocumentAddIcon } from "@solar-icons/react/outline/document-add";
import { SquareTransferHorizontalIcon } from "@solar-icons/react/outline/square-transfer-horizontal";
import { TransferHorizontalIcon } from "@solar-icons/react/outline/transfer-horizontal";
import { RouteIcon } from "@solar-icons/react/outline/route";
import { CloseCircleIcon } from "@solar-icons/react/outline/close-circle";
import { ShieldCheckIcon } from "@solar-icons/react/outline/shield-check";
import { BoxMinimalisticIcon } from "@solar-icons/react/outline/box-minimalistic";
import { FolderWithFilesIcon } from "@solar-icons/react/outline/folder-with-files";
import { HistoryIcon } from "@solar-icons/react/outline/history";
import { FolderCheckIcon } from "@solar-icons/react/outline/folder-check";
import { FileLockIcon } from "@solar-icons/react/outline/file-lock";
import { LockIcon } from "@solar-icons/react/outline/lock";
import { LockUnlockedIcon } from "@solar-icons/react/outline/lock-unlocked";
import { FileCheckIcon } from "@solar-icons/react/outline/file-check";
import { MailboxIcon } from "@solar-icons/react/outline/mailbox";
import { ChatSquareIcon } from "@solar-icons/react/outline/chat-square";
import { FileSendIcon } from "@solar-icons/react/outline/file-send";
import { GlobalIcon } from "@solar-icons/react/outline/global";
import { DeliveryIcon } from "@solar-icons/react/outline/delivery";
import { FileSpreadsheetIcon } from "@solar-icons/react/outline/file-spreadsheet";
import { FileTerminalIcon } from "@solar-icons/react/outline/file-terminal";
import { ServerSquareIcon } from "@solar-icons/react/outline/server-square";
import { ClockCircleIcon } from "@solar-icons/react/outline/clock-circle";
import { ChatDotsIcon } from "@solar-icons/react/outline/chat-dots";
import { Link } from "react-router-dom";
const SIZE = 20;

export default [
  {
    key: "/home",
    icon: <Home2Icon size={SIZE} />,
    label: <Link to={"/home"}>Home</Link>,
    level: 0x1fff,
  },
  {
    key: "/master",
    icon: <DatabaseIcon size={SIZE} />,
    label: "Master",
    level: 0x1ff0,
    children: [
      {
        key: "/master/config",
        icon: <Tuning2Icon size={SIZE} />,
        label: <Link to={"/master/config"}>Config</Link>,
        level: 0x1ff0,
      },
      {
        key: "/master/airline",
        icon: <PlaneIcon size={SIZE} />,
        label: <Link to={"/master/airline"}>Airlines</Link>,
        level: 0x1ff0,
      },
      {
        key: "/master/airport",
        icon: <CityIcon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/airport"}>Airport</Link>,
      },
      {
        key: "/master/consignee",
        icon: <Buildings2Icon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/consignee"}>Consignee</Link>,
      },
      {
        key: "/master/hscode",
        icon: <CaseMinimalisticIcon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/hscode"}>HS Code</Link>,
      },
      {
        key: "/master/warehouse",
        icon: <Shop2Icon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/warehouse"}>Warehouse</Link>,
      },

      {
        key: "/master/pjt",
        icon: <Buildings3Icon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/pjt"}>PJT</Link>,
      },
      {
        key: "/master/user_pjt",
        icon: <UserIdIcon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/user_pjt"}>Users PJT</Link>,
      },

      {
        key: "/master/users",
        icon: <UsersGroupRoundedIcon size={SIZE} />,
        level: 0x1ff0,
        label: <Link to={"/master/users"}>Users</Link>,
      },
    ],
  },
  {
    key: "/fr",
    icon: <PointOnMapIcon size={SIZE} />,
    label: "Flight Record",
    level: 0x1ff0,
    children: [
      {
        key: "/fr/departure",
        icon: <ExportIcon size={SIZE} />,
        level: 0x1fff,
        label: <Link to={"/fr/departure"}>Departure</Link>,
      },
      {
        key: "/fr/arrival",
        icon: <ImportIcon size={SIZE} />,
        level: 0x1fff,
        label: <Link to={"/fr/arrival"}>Arrival</Link>,
      },
    ],
  },
  {
    key: "/verify",
    icon: <ChatRoundCheckIcon size={SIZE} />,
    level: 0x1ff3,
    label: "Verify Document",
    children: [
      {
        key: "/verify/export",
        icon: <ExportIcon size={SIZE} />,
        level: 0x1ff1,
        label: <Link to={"/verify/export"}>Export</Link>,
      },
      {
        key: "/verify/import",
        icon: <ImportIcon size={SIZE} />,
        level: 0x1ff2,
        label: <Link to={"/verify/import"}>Import</Link>,
      },
      {
        key: "/verify/import_pjt",
        icon: <ImportIcon size={SIZE} />,
        level: 0x1ff2,
        label: <Link to={"/verify/import_pjt"}>Import PJT</Link>,
      },
      {
        key: "/verify/import_document_report",
        icon: <TagPriceIcon size={SIZE} />,
        level: 0x1ff2,
        label: <Link to={"/verify/import_document_report"}>Document Import</Link>,
      },
      {
        key: "/verify/document_pjt",
        icon: <FileTextIcon size={SIZE} />,
        level: 0x1ff2,
        label: <Link to={"/verify/document_pjt"}>Document PJT</Link>,
      },
    ],
  },
  {
    key: "/tps",
    icon: <BuildingsIcon size={SIZE} />,
    level: 0x1ff17,
    label: "TPS Online",
    children: [
      {
        key: "/tps/export",
        icon: <ExportIcon size={SIZE} />,
        level: 0x1ff5,
        label: "Export",
        children: [
          {
            key: "/tps/export/awb",
            icon: <InboxOutIcon size={SIZE} />,
            level: 0x1ff1,
            label: <Link to={"/tps/export/awb"}>AWB Export</Link>,
          },
          {
            key: "/tps/export/export_in",
            icon: <SafeSquareIcon size={SIZE} />,
            level: 0x1ff1,
            label: <Link to={"/tps/export/export_in"}>Export Gate In</Link>,
          },
          {
            key: "/tps/export/export_out",
            icon: <SafeCircleIcon size={SIZE} />,
            level: 0x1ff1,
            label: <Link to={"/tps/export/export_out"}>Export Gate Out</Link>,
          },
          {
            key: "/tps/export/export_list",
            icon: <DocumentTextIcon size={SIZE} />,
            level: 0x1ff5,
            label: <Link to={"/tps/export/export_list"}>Export List</Link>,
          },
          {
            key: "/tps/export/export_report",
            icon: <TagPriceIcon size={SIZE} />,
            level: 0x1ff1,
            label: <Link to={"/tps/export/export_report"}>Export Report</Link>,
          },
        ],
      },
      {
        key: "/tps/import",
        icon: <ImportIcon size={SIZE} />,
        level: 0x1ff6,
        label: "Import",
        children: [
          {
            key: "/tps/import/awb",
            icon: <InboxInIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import/awb"}>AWB Import</Link>,
          },
          {
            key: "/tps/import/import_in",
            icon: <SafeSquareIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import/import_in"}>Import Gate In</Link>,
          },
          {
            key: "/tps/import/import_out",
            icon: <SafeCircleIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import/import_out"}>Import Gate Out</Link>,
          },
          {
            key: "/tps/import/import_list",
            icon: <DocumentTextIcon size={SIZE} />,
            level: 0x1ff6,
            label: <Link to={"/tps/import/import_list"}>Import List</Link>,
          },
          {
            key: "/tps/import/import_report",
            icon: <TagPriceIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import/import_report"}>Import Report</Link>,
          },
        ],
      },
      {
        key: "/tps/import_pjt",
        icon: <ImportIcon size={SIZE} />,
        level: 0x1ff6,
        label: "Import PJT",
        children: [
          {
            key: "/tps/import_pjt/import_in",
            icon: <SafeSquareIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import_pjt/import_in"}>Import Gate In</Link>,
          },
          {
            key: "/tps/import_pjt/import_out",
            icon: <SafeCircleIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import_pjt/import_out"}>Import Gate Out</Link>,
          },
          {
            key: "/tps/import_pjt/import_list",
            icon: <DocumentTextIcon size={SIZE} />,
            level: 0x1ff6,
            label: <Link to={"/tps/import_pjt/import_list"}>Import List</Link>,
          },
          {
            key: "/tps/import_pjt/import_report",
            icon: <TagPriceIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/import_pjt/import_report"}>Import Report</Link>,
          },
        ],
      },
      {
        key: "/tps/distribusi",
        icon: <SquareTransferHorizontalIcon size={SIZE} />,
        level: 0x1ff6,
        label: "Distribusi",
        children: [
          {
            key: "/tps/distribusi/awb",
            icon: <TransferHorizontalIcon size={SIZE} />,
            level: 0x1ff2,
            label: <Link to={"/tps/distribusi/awb"}>AWB Distribusi</Link>,
          },
          {
            key: "/tps/distribusi/distribusi_in",
            icon: <SafeSquareIcon size={SIZE} />,
            level: 0x1ff2,
            label: (
              <Link to={"/tps/distribusi/distribusi_in"}>Distribusi Gate In</Link>
            ),
          },
          {
            key: "/tps/distribusi/distribusi_out",
            icon: <SafeCircleIcon size={SIZE} />,
            level: 0x1ff2,
            label: (
              <Link to={"/tps/distribusi/distribusi_out"}>Distribusi Gate Out</Link>
            ),
          },
          {
            key: "/tps/distribusi/distribusi_list",
            icon: <DocumentTextIcon size={SIZE} />,
            level: 0x1ff6,
            label: (
              <Link to={"/tps/distribusi/distribusi_list"}>
                Distribusi List
              </Link>
            ),
          },
          {
            key: "/tps/distribusi/distribusi_report",
            icon: <TagPriceIcon size={SIZE} />,
            level: 0x1ff2,
            label: (
              <Link to={"/tps/distribusi/distribusi_report"}>
                Distribusi Report
              </Link>
            ),
          },
        ],
      },

      {
        key: "/tps/plp",
        icon: <RouteIcon size={SIZE} />,
        level: 0x1ff11,
        label: "PLP",
        children: [
          {
            key: "/tps/plp/response",
            icon: <InboxOutIcon size={SIZE} />,
            level: 0x1ff11,
            label: <Link to={"/tps/plp/response"}>Response PLP</Link>,
          },
          {
            key: "/tps/plp/permohonan",
            icon: <DocumentAddIcon size={SIZE} />,
            level: 0x1ff11,
            label: <Link to={"/tps/plp/permohonan"}>Permohonan PLP</Link>,
          },
          {
            key: "/tps/plp/pembatalan",
            icon: <CloseCircleIcon size={SIZE} />,
            level: 0x1ff11,
            label: <Link to={"/tps/plp/pembatalan"}>Batal PLP</Link>,
          },
        ],
      },
      {
        key: "/tps/cek_data",
        icon: <DocumentTextIcon size={SIZE} />,
        level: 0x1fff,
        label: "Cek Data",
        children: [
          {
            key: "/tps/cek_data/terkirim",
            icon: <FileSendIcon size={SIZE} />,
            level: 0x1fff,
            label: <Link to={"/tps/cek_data/terkirim"}>Terkirim</Link>,
          },
          {
            key: "/tps/cek_data/reject",
            icon: <CloseCircleIcon size={SIZE} />,
            level: 0x1fff,
            label: <Link to={"/tps/cek_data/reject"}>Reject</Link>,
          },
        ],
      },
    ],
  },
  {
    key: "/beacukai",
    icon: <ShieldCheckIcon size={SIZE} />,
    level: 0x1fff,
    label: "Beacukai",
    children: [
      {
        key: "/beacukai/inventory",
        icon: <BoxMinimalisticIcon size={SIZE} />,
        level: 0x1fff,
        label: "Inventory",
        children: [
          {
            key: "/beacukai/inventory/export",
            icon: <ExportIcon size={SIZE} />,
            level: 0x1ff5,
            label: "Export",
            children: [
              {
                key: "/beacukai/inventory/export/inventory",
                icon: <FolderWithFilesIcon size={SIZE} />,
                level: 0x1ff5,
                label: (
                  <Link to={"/beacukai/inventory/export/inventory"}>
                    Inventory
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/export/abandon",
                icon: <HistoryIcon size={SIZE} />,
                level: 0x1ff5,
                label: (
                  <Link to={"/beacukai/inventory/export/abandon"}>Abandon</Link>
                ),
              },
              {
                key: "/beacukai/inventory/export/current_now",
                icon: <HistoryIcon size={SIZE} />,
                level: 0x1ff5,
                label: (
                  <Link to={"/beacukai/inventory/export/current_now"}>
                    Current Now
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/export/custome_module",
                icon: <FolderCheckIcon size={SIZE} />,
                level: 0x1ff5,
                label: (
                  <Link to={"/beacukai/inventory/export/custome_module"}>
                    Customs Module
                  </Link>
                ),
              },
            ],
          },
          {
            key: "/beacukai/inventory/import/inventory",
            icon: <ImportIcon size={SIZE} />,
            level: 0x1ff6,
            label: "Import",
            children: [
              {
                key: "/beacukai/inventory/import/inventory",
                icon: <FolderWithFilesIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/import/inventory"}>
                    Inventory
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/import/abandon",
                icon: <HistoryIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/import/abandon"}>Abandon</Link>
                ),
              },
              {
                key: "/beacukai/inventory/import/current_now",
                icon: <HistoryIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/import/current_now"}>
                    Current Now
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/import/custome_module",
                icon: <FolderCheckIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/import/custome_module"}>
                    Customs Module
                  </Link>
                ),
              },
            ],
          },
          {
            key: "/beacukai/inventory/distribusi/inventory",
            icon: <SquareTransferHorizontalIcon size={SIZE} />,
            level: 0x1ff6,
            label: "Distribusi",
            children: [
              {
                key: "/beacukai/inventory/distribusi/inventory",
                icon: <FolderWithFilesIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/distribusi/inventory"}>
                    Inventory
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/distribusi/abandon",
                icon: <HistoryIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/distribusi/abandon"}>
                    Abandon
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/distribusi/current_now",
                icon: <HistoryIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/distribusi/current_now"}>
                    Current Now
                  </Link>
                ),
              },
              {
                key: "/beacukai/inventory/distribusi/custome_module",
                icon: <FolderCheckIcon size={SIZE} />,
                level: 0x1ff6,
                label: (
                  <Link to={"/beacukai/inventory/distribusi/custome_module"}>
                    Customs Module
                  </Link>
                ),
              },
            ],
          },
        ],
      },
      {
        key: "/beacukai/hold_release",
        icon: <FileLockIcon size={SIZE} />,
        level: 0x1ff4,
        label: "Hold & Release",
        children: [
          {
            key: "/beacukai/hold_release/hold",
            icon: <LockIcon size={SIZE} />,
            level: 0x1ff4,
            label: (
              <Link to={"/beacukai/hold_release/hold"}>
                Hold
              </Link>
            ),
          },
          {
            key: "/beacukai/hold_release/release",
            icon: <LockUnlockedIcon size={SIZE} />,
            level: 0x1ff4,
            label: (
              <Link to={"/beacukai/hold_release/release"}>
                Release
              </Link>
            ),
          },
          {
            key: "/beacukai/hold_release/report",
            icon: <TagPriceIcon size={SIZE} />,
            level: 0x1ff4,
            label: (
              <Link to={"/beacukai/hold_release/report"}>
                Report
              </Link>
            ),
          },
        ]
      },

      {
        key: "/beacukai/custome_clearance",
        icon: <FileCheckIcon size={SIZE} />,
        level: 0x1ff4,
        label: "Custome Clearance",
        children: [
          {
            key: "/beacukai/custome_clearance/export",
            icon: <ExportIcon size={SIZE} />,
            level: 0x1ff4,
            label: (
              <Link to={"/beacukai/custome_clearance/export"}>
                Export
              </Link>
            ),
          },
          {
            key: "/beacukai/custome_clearance/import",
            icon: <ImportIcon size={SIZE} />,
            level: 0x1ff4,
            label: (
              <Link to={"/beacukai/custome_clearance/import"}>
                Import
              </Link>
            ),
          },
        ]
      }
    ],
  },
  {
    key: "/beacukai-v2",
    icon: <BuildingsIcon size={SIZE} />,
    level: 0x1fff,
    label: "Beacukai V2",
    children: [
      {
        key: "/beacukai-v2/tps",
        icon: <Buildings2Icon size={SIZE} />,
        level: 0x1ff5,
        label: (
          <Link to={"/beacukai-v2/tps"}>
            Dashboard TPS
          </Link>
        ),
      },
      {
        key: "/beacukai-v2/inventory",
        icon: <DatabaseIcon size={SIZE} />,
        level: 0x1ff5,
        label: (
          <Link to={"/beacukai-v2/inventory"}>
            Inventory
          </Link>
        ),
      },
      {
        key: "/beacukai-v2/current-now",
        icon: <PointOnMapIcon size={SIZE} />,
        level: 0x1ff5,
        label: (
          <Link to={"/beacukai-v2/current-now"}>
            Current Now
          </Link>
        ),
      },
      {
        key: "/beacukai-v2/customs-hold",
        icon: <LockIcon size={SIZE} />,
        level: 0x1ff5,
        label: (
          <Link to={"/beacukai-v2/customs-hold"}>
            Customs Hold
          </Link>
        ),
      },
      {
        key: "/beacukai-v2/ebandon",
        icon: <InboxIcon size={SIZE} />,
        level: 0x1ff5,
        label: (
          <Link to={"/beacukai-v2/ebandon"}>
            Ebandon
          </Link>
        ),
      },
      {
        key: "/beacukai-v2/report",
        icon: <DocumentTextIcon size={SIZE} />,
        level: 0x1ff5,
        label: (
          <Link to={"/beacukai-v2/report"}>
            Laporan
          </Link>
        ),
      },
    ],
  },
  {
    key: "/telex",
    icon: <MailboxIcon size={SIZE} />,
    level: 0x1ffb,
    label: "Converter",
    children: [
      {
        key: "/airwaybill/import/import_in",
        icon: <SafeSquareIcon size={SIZE} />,
        level: 0x1ff8,
        label: <Link to={"/airwaybill/import/import_in"}>Import Gate In</Link>,
      },
      {
        key: "/logs/telex",
        icon: <ChatSquareIcon size={SIZE} />,
        level: 0x1ff8,
        label: <Link to={"/logs/telex"}>Telex Message</Link>,
      },
      {
        key: "/telex/airwaybill",
        icon: <InboxIcon size={SIZE} />,
        level: 0x1ff8,
        label: <Link to={"/telex/airwaybill"}>Awb Telex</Link>,
      },
      {
        key: "/telex/tps",
        icon: <FileSendIcon size={SIZE} />,
        level: 0x1ffb,
        label: "Manifest",
        children: [
          {
            key: "/telex/international/transit",
            icon: <GlobalIcon size={SIZE} />,
            level: 0x1ffb,
            label: "International",
            children: [
              {
                key: "/telex/international/transit",
                icon: <TransferHorizontalIcon size={SIZE} />,
                level: 0x1ffb,
                label: <Link to={"/telex/international/transit"}>Transit</Link>,
              },
              {
                key: "/telex/international/destination",
                icon: <PointOnMapIcon size={SIZE} />,
                level: 0x1ffb,
                label: <Link to={"/telex/international/destination"}>Destination</Link>,
              },
            ],
          },
          {
            key: "/telex/domestic",
            icon: <DeliveryIcon size={SIZE} />,
            level: 0x1ffb,
            label: <Link to={"/telex/domestic"}>Domestic</Link>,
          },
        ],
      },
      {
        key: "/telex/rksp",
        icon: <FileSpreadsheetIcon size={SIZE} />,
        level: 0x1ff8,
        label: <Link to={"/telex/rksp"}>Rksp</Link>,
      },
      {
        key: "/telex/rksp_log",
        icon: <DocumentTextIcon size={SIZE} />,
        level: 0x1ff8,
        label: <Link to={"/telex/rksp_log"}>Rksp Logs</Link>,
      }
    ],
  },
  {
    key: "/logs",
    icon: <FileTerminalIcon size={SIZE} />,
    level: 0x1ff4,
    label: "Logs",
    children: [
      {
        key: "/logs/job",
        icon: <ServerSquareIcon size={SIZE} />,
        level: 0x1ff2,
        label: <Link to={"/logs/job"}>Job</Link>,
      },
      {
        key: "/logs/activity",
        icon: <ClockCircleIcon size={SIZE} />,
        level: 0x1ff2,
        label: <Link to={"/logs/activity"}>Activity</Link>,
      },
      {
        key: "/logs/message",
        icon: <ChatDotsIcon size={SIZE} />,
        level: 0x1ff4,
        label: <Link to={"/logs/message"}>Message</Link>,
      },
    ],
  }
];
